"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

declare global {
  interface Window {
    _paq?: Array<Array<string | number | boolean | undefined>>;
  }
}

const matomoUrl = process.env.NEXT_PUBLIC_MATOMO_URL?.replace(/\/+$/, "");
const siteId = process.env.NEXT_PUBLIC_MATOMO_SITE_ID;

export default function MatomoTracker() {
  const pathname = usePathname();
  const initialized = useRef(false);
  const lastTrackedUrl = useRef("");

  useEffect(() => {
    if (!matomoUrl || !siteId || typeof window === "undefined") return;

    window._paq = window._paq || [];

    if (!initialized.current) {
      window._paq.push(["enableLinkTracking"]);
      window._paq.push(["setTrackerUrl", `${matomoUrl}/matomo.php`]);
      window._paq.push(["setSiteId", siteId]);

      const script = document.createElement("script");
      script.async = true;
      script.src = `${matomoUrl}/matomo.js`;
      document.head.appendChild(script);

      initialized.current = true;
    }

    const url = window.location.href;

    if (lastTrackedUrl.current === url) return;
    lastTrackedUrl.current = url;

    window._paq.push(["setCustomUrl", url]);
    window._paq.push(["setDocumentTitle", document.title]);
    window._paq.push(["trackPageView"]);
  }, [pathname]);

  return null;
}
